<template>
  <main >
    <RomaListActivities />
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RomaListActivities from "@/components/activity/RomaListActivities.vue";
export default {
  data() {
    return {
      buttonOptions: {
        title: "Lista de actividades",
        icon: "mdi-plus",
        color: "accent",
      },
    };
  },
  components: {
    RomaListActivities,
  },
  mounted() {
    this.setLayout("main-layout");
  },
  computed: {
    ...mapGetters({
      layout: "getLayout",
    }),
  },
  methods: {
    ...mapActions({
      setLayout: "setLayout",
      toastSuccess: "toastSuccess",
      toastError: "toastError",
    }),
  },
};
</script>
